<template>
<div>
  <div>
    <span>{{completion.optionContent}}</span>
  </div>

  <div class="data-wrapper">
    <label class="labelStyle">仪器流量显示值</label>
    <label>:</label>
    <input
      v-model="completion.theoryValue"
      type="number"
      class="input"
      @input="onInput"
    />
    <span>{{completion.unit || 'mL/min'}}</span>

    <label class="labelStyle">参考流量计读数</label>
    <label>:</label>
    <input
      v-model="completion.inputValue"
      type="number"
      class="input"
      @input="onInput"
    />
    <span>{{completion.unit || 'mL/min'}}</span>

    <label>参考流量计修正值</label>
    <label>:</label>
    <span v-if="isCompleted">{{measureInstrument.a}} × {{completion.inputValue}} + {{measureInstrument.b}} = <span style="color:#409EFF;">{{Number(completion.value.toFixed(7))}}</span></span>
    <span v-else>--</span>
    <span></span>

    <label>偏差</label>
    <label>:</label>
    <span
      v-if="isCompleted"
      :style="{color: isQualified ? 'green' : 'red'}"
    >{{(completion.resultValue * 100).toFixed(2)}}%</span>
    <span v-else class="diff">--</span>
    <span></span>
  </div>
</div>
</template>

<script>
import BaseFormula from '../BaseFormula'

export default {
  name: 'SectionBlanks',
  extends: BaseFormula,
  getSelected: opt => `仪器流量显示值:${opt.theoryValue}, 参考流量计读数:${opt.inputValue}`,
  computed: {
    measureInstrumentMap () {
      return this.measureInstruments.reduce((map, measureInstrument) => {
        map[measureInstrument.id] = measureInstrument
        return map
      }, {})
    },
    measureInstrument () {
      return this.measureInstrumentMap[this.completion.taskMeasureInstrumentId]
    },
    theoryValue () {
      let theoryValue = this.completion.theoryValue
      return typeof theoryValue === 'number' ? theoryValue : (theoryValue ? Number(theoryValue) : null)
    },
    realValue () {
      let realValue = this.completion.value
      return typeof realValue === 'number' ? realValue : (realValue ? Number(realValue) : null)
    },
    threshold () {
      return this.completion.threshold
    },
    isCompleted () {
      return typeof this.theoryValue === 'number' && typeof this.realValue === 'number'
    },
    isQualified () {
      let {resultValue} = this.completion
      return this.compare(Math.abs(resultValue), this.threshold / 2) ? 1 : (this.compare(Math.abs(resultValue), this.threshold) ? 0.5 : 0)
    }
  },
  methods: {
    getRealValue (inputValue) {
      let {measureInstrument} = this
      return measureInstrument && Number.isFinite(Number(inputValue)) ? (measureInstrument.a * inputValue + measureInstrument.b) : null
    },
    setParam () {
      let completion = this.completion
      completion.isCompleted = this.isCompleted
      completion.isQualified = this.isQualified
    },
    onInput () {
      let {completion} = this
      completion.value = this.getRealValue(completion.inputValue)
      let {theoryValue, realValue} = this
      this.completion.resultValue = Number(((realValue - theoryValue) / theoryValue).toFixed(7))
      this.setParam()
      this.$emit('complete-change')
    }
  },
  watch: {
    measureInstrument () {
      this.onInput()
    }
  },
  created () {
    let {completion} = this

    // if (measureInstruments.length > 0 && !completion.hasOwnProperty('taskMeasureInstrumentId')) {
    //   this.$set(completion, 'taskMeasureInstrumentId', measureInstruments[0].id)
    // }

    if (!completion.hasOwnProperty('value')) {
      this.$set(completion, 'value', null)
    }

    this.setParam()
  }
}
</script>

<style lang="scss" scoped>
.data-wrapper {
  display: grid;
  grid-template-columns: repeat(4, max-content);
  grid-row-gap: 5px;
  align-items: center;
  padding-top: 5px;

  > label {
    text-align: justify;
    text-align-last: justify;

    & + :not(label) {
      margin-left: 10px;

      & + * {
        margin-left: 10px;
      }
    }
  }
}
/*.form-input {*/
/*  margin-top: 5px;*/
/*}*/

/*.input {*/
/*  margin-left: 10px;*/
/*}*/

/*.diff {*/
/*  margin-left: 22px;*/
/*}*/
/*.labelStyle {*/
/*  display:inline-block;*/
/*  text-align: justify;*/
/*  text-align-last: justify;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/Data/TaskResult/Completion/Formula/SectionBlanks.vue